import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_DETAILS_SHARE_CTA_PLACEMENT = defineFcm('petition_details_share_cta_placement')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Mobile Action Button',
		description:
			'Rollout kill switch for the productized share CTA placement (full-width "Share this petition" button below Sign) on the petition details page mobile action button, independent of Experiment Service assignment. Also gates the clean re-run of the placement experiment (CHANGE-98647).\n\nhttps://change.atlassian.net/browse/CHANGE-94948\nhttps://change.atlassian.net/browse/CHANGE-97649\nhttps://change.atlassian.net/browse/CHANGE-98647',
		template: {
			enabled: true,
		},
		import: false,
	});
